export const CONFIGURED_INTEGRATIONS_RESOURCE_KEY = 'configuredIntegrationsResource';
export const PAGE_KEY = 'page';
export const NAME_KEY = 'keyword';
export const TYPE_KEY = 'group';
export const STATUS_KEY = 'status';
export const TEAMID_KEY = 'teamId';